import { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { StoreContext } from "../../../../../../store/StoreProvider";
import TopPanel from "./components/topPanel/TopPanel";
// eslint-disable-next-line import/no-cycle
import { getAiContent } from "./AiUtils";
import Act from "../../../../../../store/actions";
import StyledMain from "../component/StyledMain";

const AiPage = () => {
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { currentPage } = sna.AI;
  const { open } = sna.sidebar;
  const mainContain = getAiContent(currentPage);

  useEffect(() => {
    const apiStr = process.env.REACT_APP_AI_QUOTA_API;
    (async () => {
      const data = await axios.post(apiStr);
      const curUsage = data?.data;
      const quotaPercentage = Math.floor((1 - curUsage) * 100);
      const isQuotaExceeded = quotaPercentage <= 0;

      dispatch({
        type: Act.SNA_SET_QUOTA,
        payload: isQuotaExceeded ? 0 : quotaPercentage,
      });

      if (isQuotaExceeded) {
        dispatch({
          type: Act.SNA_SET_AI_QUOTA,
          payload: isQuotaExceeded,
        });
      }
    })();
  }, []);

  return (
    <StyledMain open={open}>
      <Grid className="DigitalAITool__AI" px={3} py={2} sx={{ height: "100%" }}>
        <Grid>
          <TopPanel />
        </Grid>
        <Grid sx={{ height: "calc(100% - 72px)" }}>{mainContain}</Grid>
      </Grid>
    </StyledMain>
  );
};

export default AiPage;
